import template from './rw-location-selector-dialog.html';

const mapStateToThis = () => ({});

const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class RwLocationSelectorDialogController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  onClose(retailer) {
    this.close({ $value: retailer });
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class RwLocationSelectorDialogComponent {
  constructor() {
    this.template = template;
    this.controller = RwLocationSelectorDialogController;
    this.bindings = {
      resolve: '<',
      close: '&',
      dismiss: '&',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-location-selector/components/rw-location-selector-dialog/rw-location-selector-dialog-component.js